/* eslint-disable no-unused-vars */
import Sidebar from './Sidebar';
import ChatInput from './ChatInput';
import { connect } from 'react-redux';
import { constant } from './constants';
import ChatMessage from './ChatMessage';
import { bindActionCreators } from 'redux';
import TypingIndicator from './TypingIndicator';
import translation from '../../utils/translation';
import { ChatContainer, MessageList } from './CSS/styles';
import React, { useState, useEffect, useRef } from 'react';
import LayoutAction from '../../modules/actions/LayoutAction';
import { getConversationList, setNewMessage } from './Utils/ApICalls';

const Chat = (props) => {
  const bottomRef = useRef({});
  let [messages, setMessages] = useState([]);
  const [currentChatId, setCurrentChatId] = useState('');
  const [loading, setLoading] = useState(false);
  const translationCache = props.translationCache || {};

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [messages]);

  useEffect(() => {
    if (props.LayoutAction && props.LayoutAction.getLoggedInProfile) {
      props.LayoutAction.getLoggedInProfile();
    }
  }, [props.LayoutAction]);

  const onNewChatCreated = async (ConversationId, Content) => {
    let getLastRecord = messages && Array.isArray(messages) ? messages[messages.length - 1] : [];
    let DebugMode =
      getLastRecord && getLastRecord.DebugStatus ? getLastRecord.DebugStatus : 'DISABLED';

    let payload = {
      ConversationId,
      Content,
      UserType: 'User',
      DebugMode
    };
    messages.push(payload);
    setMessages(messages);
    setLoading(true);
    let newMessageResp = await setNewMessage(payload);
    if (newMessageResp && newMessageResp.Id) {
      getConversationListData(ConversationId);
      setCurrentChatId(ConversationId);
    }
  };

  const getConversationListData = async (currentChatId) => {
    let messages = await getConversationList(currentChatId);
    setMessages(messages);
    setLoading(false);
  };

  const onChatSelected = (currentChatId) => {
    if (currentChatId) {
      getConversationListData(currentChatId);
      setCurrentChatId(currentChatId);
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar onChatSelected={(chatId) => onChatSelected(chatId)} selectedChatId={currentChatId} />
      <>
        <ChatContainer>
          <>
            {messages && Array.isArray(messages) && messages.length > 0 ? (
              <>
                <MessageList>
                  <div style={{ margin: '20px' }}>
                    {messages.map((message, index) => (
                      <ChatMessage
                        key={index}
                        sender={message.UserType}
                        generatedDate={message.CreatedTime}
                        content={message.Content}
                        message={message}
                        Id={message.Id}
                        Feedback={message.Feedback}
                        isUser={message.UserType.toLowerCase() === 'user'}
                        refreshList={() => getConversationListData(currentChatId)}
                      />
                    ))}
                    <TypingIndicator isTyping={loading} />
                  </div>
                  <div ref={bottomRef} />
                </MessageList>
              </>
            ) : (
              <>
                <MessageList>
                  <div
                    style={{
                      margin: '20px',
                      fontWeight: 'bold',
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    <span>
                      {translation(
                        translationCache,
                        constant.Hi_there_Welcome_to_BM_GPT_How_can_i_help_you
                      )}
                    </span>
                  </div>
                  <div ref={bottomRef} />
                </MessageList>
              </>
            )}
          </>
          <ChatInput
            onNewUserMessage={(ConversationId, Content) =>
              onNewChatCreated(ConversationId, Content)
            }
            onNewChatCreated={(ConversationId, Content) =>
              onNewChatCreated(ConversationId, Content)
            }
            chatId={currentChatId}
            getConversationList={(ChatId) => getConversationListData(ChatId)}
            messages={messages}
          />
        </ChatContainer>
      </>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    LayoutAction: bindActionCreators(LayoutAction, dispatch)
  };
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

const ChatApplication = connect(mapStateToProps, mapDispatchToProps)(Chat);

export default ChatApplication;
